export enum PostType {
	TEXT = "text",
	GOAL = "goal",
	SUB = "sub",
	POLL = "poll",
	POLL_RESULT = "poll_result",
	FAN_COMMENT = "fan_comment",
	KEY_MOMENT = "key_moment",
	TIME_EVENT = "time_event",
	CARD = "card",
	CORRECTION = "correction",
	VAR = "var",
	PENALTY = "penalty",
}

export type KeyMomentType = "chance" | "big_chance";

export type Post = {
	id: string;
	text: string;
	date: string;
	type: PostType;
	// Snapshotted server-side at creation time (see server/lib/match-minute.ts)
	// so a later time correction can't reshape an already-created post's
	// displayed minute. Absent on posts created before this existed —
	// useMatchMinute falls back to the dynamic calculation for those.
	minute?: string | null;
	hashtags?: string[];
	sharedToBluesky?: boolean;
	keyMomentType?: KeyMomentType;
	userName?: string;
	team?: "home" | "away";
	teamId?: number;
	scorerId?: number;
	playerId?: number;
	cardType?: "yellow" | "2Yellow" | "red";
	pollId?: string;
};
